"use client";
import { useEffect } from "react";
import { Stack } from "@mui/material";

import { observer, useStore } from "../../../../../service/mobx";
import { Container } from "..";
import { OutputJSON } from "../InputBox/useIO";

function OutputBox({ label, Output, small = false }) {
  const { model } = useStore();
  const noInput = model.input === undefined;

  useEffect(() => {
    if (noInput) {
      let objectUrl;

      fetch(`/api/model/widget/${model.node.modelId}`).then(async res => {
        const contentType = res.headers.get("content-type")?.split("/")[0];

        if (contentType === "application") {
          const { output } = await res.json();

          model.set.output(output);
        } else if (contentType === "text") {
          model.set.output(await res.text());
        } else if (
          contentType === "audio" ||
          contentType === "image" ||
          contentType === "video"
        ) {
          objectUrl = URL.createObjectURL(await res.blob());

          model.set.output(objectUrl);
        }
      });

      return () => {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
      };
    }
  }, [model, noInput]);

  return model.output || model.error ? (
    <Container label={label} small={small}>
      <Stack
        useFlexGap
        spacing={3}
        height="100%"
        justifyContent="space-between"
      >
        {model.error ? (
          <OutputJSON output={{ error: model.error }} />
        ) : (
          <Output
            task={model.task}
            input={model.input}
            output={model.error || model.output}
          />
        )}
      </Stack>
    </Container>
  ) : null;
}

export default observer(OutputBox);
